<template>
  <div style="width: 100%; height: 400px"></div>
</template>

<script>
  import * as echarts from 'echarts'

  require('echarts/theme/macarons')

  export default {
    props: {
      chartData: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        chart: null
      }
    },
    watch: {
      chartData: {
        deep: true,
        handler (val) {
          this.setOptions(val)
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.initChart()
      })
    },
    beforeDestroy () {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      initChart () {
        this.chart = echarts.init(this.$el)
        this.setOptions()
      },
      setOptions () {
        // dataType 数据类型 1-新建商机 2-赢单商机
        let series = {}
        if (this.chartData.dataType === 1) {
          series = {
            name: '新增商机',
            data: this.chartData.data,
            type: 'line',
            smooth: false,
            lineStyle: {
              color: '#0aa0b1'
            },
            itemStyle: {
              normal: {
                label: {show: true},
                color: '#0aa0b1'
              }
            }
          }
        }else if(this.chartData.dataType === 'trend'){
          series = {
            name: '销售',
            data: this.chartData.data,
            type: 'line',
            smooth: false,
            lineStyle: {
              color: '#0aa0b1'
            },
            itemStyle: {
              normal: {
                label: {show: true},
                color: '#0aa0b1'
              }
            }
          }
        } else {
          series = {
            name: '赢单商机',
            data: this.chartData.data,
            type: 'line',
            smooth: false,
            lineStyle: {
              color: '#ca5757',
            },
            itemStyle: {
              normal: {
                label: {show: true},
                color: '#ca5757'
              }
            }
          }
        }
        this.chart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          // legend: {
          //   data: ['新增商机', '赢单商机']
          // },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          yAxis: {
            type: 'value'
          },
          series: [series]
        })
      }
    }
  }
</script>
